export default __webpack_public_path__ + "static/media/Injection contraceptive.0fdfab36.jpg";